import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { TimePicker, Form } from "antd";
import { createUseStyles } from "react-jss";

dayjs.extend(customParseFormat);

const UIFormTimePicker = ({
  label,
  name,
  required,
  rules,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  defaultValue,
  placeholder = "",
}) => {
  const styles = useStyles();
  return (
    <Form.Item
     label={ <span style={{ fontSize: "16px" , fontWeight: "500" }}>{label}</span>  }
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue ? dayjs(defaultValue, "hh:mm:ss A") : undefined}
    >
      <TimePicker
        onChange={onChange}
        disabled={disabled}
        placeholder={"Select Time"}
        format="h:mm:ss A"
        changeOnScroll={false}
        className={styles.customSelect}
      />
    </Form.Item>
  );
};

export default UIFormTimePicker;
const useStyles = createUseStyles({
  customSelect : {
    width: "100%",
    height: "51px !important",
    '& .ant-select-selector': {
      height: "50px",
      fontSize: "16px",
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
    },
    '& .ant-select-selection-item': {
      fontSize: "16px",
      fontWeight: 500,
    },
    '& .ant-select-selection-placeholder': {
      fontSize: "16px",
      fontWeight: 500,
    },
  }
});
